export default __webpack_public_path__ + "static/anita-b994e3d6f4d2c198b4c19467b19a6742.webp";